// Diallo Network - Mock Data
// Boutiques pilotes, inventaire, témoignages

// 10 boutiques pilotes à Abidjan avec coordonnées GPS
export const dialloStores = [
  {
    id: 'diallo-cocody-1',
    name: 'Diallo Cocody Riviera',
    neighborhood: 'Cocody',
    address: 'Riviera 3, près du carrefour',
    owner: 'Mamadou Diallo',
    phone: '+225 07 58 14 80 01',
    coordinates: [5.3600, -3.9700],
    openHours: '6h - 22h',
    features: ['Fruits frais', 'Légumes', 'Point de collecte'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-yopougon-1',
    name: 'Diallo Yopougon Selmer',
    neighborhood: 'Yopougon',
    address: 'Selmer, face à la pharmacie',
    owner: 'Aminata Koné',
    phone: '+225 07 58 14 80 02',
    coordinates: [5.3200, -4.0800],
    openHours: '6h - 21h',
    features: ['Fruits frais', 'Légumes', 'Épicerie'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-marcory-1',
    name: 'Diallo Marcory Zone 4',
    neighborhood: 'Marcory',
    address: 'Zone 4, rue des jardins',
    owner: 'Ibrahim Touré',
    phone: '+225 07 58 14 80 03',
    coordinates: [5.3050, -3.9850],
    openHours: '6h - 22h',
    features: ['Fruits frais', 'Légumes', 'Point de collecte'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-abobo-1',
    name: 'Diallo Abobo Gare',
    neighborhood: 'Abobo',
    address: 'Abobo Gare, près du marché',
    owner: 'Fatou Bamba',
    phone: '+225 07 58 14 80 04',
    coordinates: [5.4200, -4.0200],
    openHours: '5h30 - 21h',
    features: ['Fruits frais', 'Légumes', 'Gros volumes'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-plateau-1',
    name: 'Diallo Plateau Commerce',
    neighborhood: 'Plateau',
    address: 'Avenue Chardy, immeuble CCIA',
    owner: 'Jean-Pierre Assi',
    phone: '+225 07 58 14 80 05',
    coordinates: [5.3190, -4.0220],
    openHours: '7h - 20h',
    features: ['Fruits premium', 'Légumes bio', 'Livraison bureau'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-treichville-1',
    name: 'Diallo Treichville Avenue',
    neighborhood: 'Treichville',
    address: 'Avenue 12, près du port',
    owner: 'Kouadio Yao',
    phone: '+225 07 58 14 80 06',
    coordinates: [5.2950, -4.0050],
    openHours: '6h - 22h',
    features: ['Fruits frais', 'Légumes', 'Épicerie'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-adjame-1',
    name: 'Diallo Adjamé Liberté',
    neighborhood: 'Adjamé',
    address: 'Quartier Liberté, rue principale',
    owner: 'Mariam Sow',
    phone: '+225 07 58 14 80 07',
    coordinates: [5.3550, -4.0300],
    openHours: '5h - 22h',
    features: ['Fruits frais', 'Légumes', 'Prix marché'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-koumassi-1',
    name: 'Diallo Koumassi Remblais',
    neighborhood: 'Koumassi',
    address: 'Remblais, face à l\'école',
    owner: 'Seydou Coulibaly',
    phone: '+225 07 58 14 80 08',
    coordinates: [5.2900, -3.9500],
    openHours: '6h - 21h',
    features: ['Fruits frais', 'Légumes', 'Point de collecte'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-bingerville-1',
    name: 'Diallo Bingerville Centre',
    neighborhood: 'Bingerville',
    address: 'Centre-ville, près de la mairie',
    owner: 'Aïcha Traoré',
    phone: '+225 07 58 14 80 09',
    coordinates: [5.3500, -3.8900],
    openHours: '6h - 20h',
    features: ['Fruits frais', 'Légumes', 'Produits locaux'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  },
  {
    id: 'diallo-portbouet-1',
    name: 'Diallo Port-Bouët Vridi',
    neighborhood: 'Port-Bouët',
    address: 'Vridi Canal, avenue de la mer',
    owner: 'Pascal Gnagne',
    phone: '+225 07 58 14 80 10',
    coordinates: [5.2600, -3.9700],
    openHours: '6h - 21h',
    features: ['Fruits frais', 'Légumes', 'Poissons frais'],
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400'
  }
];

// Inventaire mock par boutique (produits Océana disponibles)
export const storeInventory = {
  'diallo-cocody-1': [
    { product: 'Mangue Kent', available: true, quantity: 'Beaucoup', price: '1500 FCFA/kg' },
    { product: 'Ananas Sweet', available: true, quantity: 'Moyen', price: '800 FCFA/pièce' },
    { product: 'Banane Cavendish', available: true, quantity: 'Beaucoup', price: '500 FCFA/kg' },
    { product: 'Avocat Hass', available: true, quantity: 'Peu', price: '1200 FCFA/pièce' },
    { product: 'Orange Navel', available: false, quantity: '0', price: '600 FCFA/kg' },
    { product: 'Pomme Golden', available: true, quantity: 'Moyen', price: '2000 FCFA/kg' },
    { product: 'Tomate', available: true, quantity: 'Beaucoup', price: '800 FCFA/kg' },
    { product: 'Oignon', available: true, quantity: 'Beaucoup', price: '500 FCFA/kg' }
  ],
  'diallo-yopougon-1': [
    { product: 'Mangue Kent', available: true, quantity: 'Moyen', price: '1500 FCFA/kg' },
    { product: 'Ananas Sweet', available: true, quantity: 'Beaucoup', price: '800 FCFA/pièce' },
    { product: 'Banane Cavendish', available: true, quantity: 'Beaucoup', price: '500 FCFA/kg' },
    { product: 'Avocat Hass', available: false, quantity: '0', price: '1200 FCFA/pièce' },
    { product: 'Orange Navel', available: true, quantity: 'Moyen', price: '600 FCFA/kg' },
    { product: 'Papaye', available: true, quantity: 'Peu', price: '700 FCFA/kg' }
  ],
  'default': [
    { product: 'Mangue Kent', available: true, quantity: 'Variable', price: '1500 FCFA/kg' },
    { product: 'Ananas Sweet', available: true, quantity: 'Variable', price: '800 FCFA/pièce' },
    { product: 'Banane Cavendish', available: true, quantity: 'Variable', price: '500 FCFA/kg' },
    { product: 'Avocat Hass', available: true, quantity: 'Variable', price: '1200 FCFA/pièce' },
    { product: 'Orange Navel', available: true, quantity: 'Variable', price: '600 FCFA/kg' }
  ]
};

// Témoignages des commerçants et clients
export const dialloTestimonials = {
  fr: {
    owners: [
      {
        id: 1,
        name: 'Mamadou Diallo',
        store: 'Diallo Cocody Riviera',
        photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
        quote: 'Depuis que ma boutique est devenue Diallo, mes ventes ont augmenté de 40%. Les clients font confiance à la marque et reviennent pour la qualité des fruits Océana.',
        since: '2024',
        highlight: '+40% de ventes'
      },
      {
        id: 2,
        name: 'Aminata Koné',
        store: 'Diallo Yopougon Selmer',
        photo: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=150',
        quote: 'La transformation a tout changé. Ma boutique est plus propre, mieux organisée, et l\'application me permet de commander facilement. Je suis fière de mon commerce.',
        since: '2024',
        highlight: 'Commandes simplifiées'
      },
      {
        id: 3,
        name: 'Ibrahim Touré',
        store: 'Diallo Marcory Zone 4',
        photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
        quote: 'Avant, j\'achetais mes fruits au marché de gros. Maintenant, je reçois des produits frais livrés directement. Moins de pertes, meilleurs prix.',
        since: '2024',
        highlight: 'Livraison directe'
      }
    ],
    customers: [
      {
        id: 1,
        name: 'Awa Cissé',
        neighborhood: 'Cocody',
        photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
        quote: 'Je fais mes courses chez Diallo chaque matin. Les fruits sont toujours frais et le prix est correct. C\'est mon "Diallo" du quartier !',
        rating: 5
      },
      {
        id: 2,
        name: 'Yves Kouamé',
        neighborhood: 'Yopougon',
        photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150',
        quote: 'Ma femme m\'envoie acheter des mangues et des avocats chez Diallo. Ils sont meilleurs que partout ailleurs. Et le commerçant connaît mes goûts !',
        rating: 5
      },
      {
        id: 3,
        name: 'Marie-Claire Aka',
        neighborhood: 'Marcory',
        photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
        quote: 'Je commande sur l\'app et je récupère au Diallo de mon quartier. Très pratique pour une maman qui travaille !',
        rating: 5
      }
    ]
  },
  en: {
    owners: [
      {
        id: 1,
        name: 'Mamadou Diallo',
        store: 'Diallo Cocody Riviera',
        photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
        quote: 'Since my shop became Diallo, my sales have increased by 40%. Customers trust the brand and come back for the quality of Océana fruits.',
        since: '2024',
        highlight: '+40% sales'
      },
      {
        id: 2,
        name: 'Aminata Koné',
        store: 'Diallo Yopougon Selmer',
        photo: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=150',
        quote: 'The transformation changed everything. My shop is cleaner, better organized, and the app makes ordering easy. I\'m proud of my business.',
        since: '2024',
        highlight: 'Simplified orders'
      },
      {
        id: 3,
        name: 'Ibrahim Touré',
        store: 'Diallo Marcory Zone 4',
        photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
        quote: 'Before, I bought my fruits at the wholesale market. Now, I receive fresh products delivered directly. Less waste, better prices.',
        since: '2024',
        highlight: 'Direct delivery'
      }
    ],
    customers: [
      {
        id: 1,
        name: 'Awa Cissé',
        neighborhood: 'Cocody',
        photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
        quote: 'I shop at Diallo every morning. The fruits are always fresh and the price is fair. It\'s my neighborhood "Diallo"!',
        rating: 5
      },
      {
        id: 2,
        name: 'Yves Kouamé',
        neighborhood: 'Yopougon',
        photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150',
        quote: 'My wife sends me to buy mangoes and avocados at Diallo. They\'re better than anywhere else. And the shopkeeper knows my tastes!',
        rating: 5
      },
      {
        id: 3,
        name: 'Marie-Claire Aka',
        neighborhood: 'Marcory',
        photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
        quote: 'I order on the app and pick up at my neighborhood Diallo. Very convenient for a working mom!',
        rating: 5
      }
    ]
  }
};

// Liste des quartiers pour le formulaire
export const abidjanNeighborhoods = [
  'Abobo', 'Adjamé', 'Attécoubé', 'Bingerville', 'Cocody', 
  'Koumassi', 'Marcory', 'Plateau', 'Port-Bouët', 'Treichville', 
  'Yopougon', 'Songon', 'Anyama', 'Autre'
];

export const getStoreInventory = (storeId) => {
  return storeInventory[storeId] || storeInventory['default'];
};

export const getStoresByNeighborhood = (neighborhood) => {
  if (!neighborhood) return dialloStores;
  return dialloStores.filter(store => 
    store.neighborhood.toLowerCase().includes(neighborhood.toLowerCase())
  );
};

export default {
  dialloStores,
  storeInventory,
  dialloTestimonials,
  abidjanNeighborhoods,
  getStoreInventory,
  getStoresByNeighborhood
};
